(function () {
  'use strict';

  var SEL = {
    section: '.vg-buy',
    flavorLabel: '.vg-buy__flavor',
    bundleLabel: '.vg-buy__bundle',
    optionCard: '.vg-buy__option',
    ctaBtn: '.vg-buy__cta-btn',
    variantInput: '.product-variant-id',
    qtyInput: '.vg-buy__qty-input',
    sellingPlanInput: '.vg-buy__selling-plan-input',
    subscribePrice: '[data-subscribe-price]',
    onetimePrice: '[data-onetime-price]',
    comparePrice: '[data-compare-price]',
    pricePerUnit: '[data-price-per-unit]',
    mixToggle: '[data-mix-toggle]',
    paneOnetime: '[data-vg-pane="onetime"]',
    paneSubscribe: '[data-vg-pane="subscribe"]',
    subQtyLabel: '.vg-buy__subqty',
    freqLabel: '.vg-buy__freq',
    subTotal: '[data-sub-total]',
    subCompare: '[data-sub-compare]',
    subQtyPrice: '[data-sub-qty-price]',
    /* 구독 유도 장치 (2026-08-04) */
    subQtyCompare: '[data-sub-qty-compare]',
    subPerBox: '[data-sub-perbox]',
    subPerBoxCompare: '[data-sub-perbox-compare]',
    subAnchor: '[data-sub-anchor]',
    subSwitch: '[data-sub-switch]',
    subSwitchText: '[data-sub-switch-text]',
    ctaFrict: '[data-cta-frict]',
  };

  var instances = new WeakMap();

  function VgBuyBox(section) {
    if (!section) return;
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this._handlers = [];

    var dataEl = document.getElementById('vg-buy-product-data-' + this.sectionId);
    if (!dataEl) return;

    try {
      this.productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    if (!this.productData || !this.productData.variants || !this.productData.variants.length) return;

    this.bundleMap = this._buildBundleMap();
    this.promoDiscountMap = this._buildPromoDiscountMap();
    this.promoApplied = false;
    this.currentOptions = this._getInitialOptions();
    this.selectedBundleQty = this._getSelectedBundleQty();
    this.purchaseType = this._getSelectedPurchaseType();
    this.isMixed = false;

    this._humanizeFreqLabels();
    this._sortFreqOptions();
    this._clearPlanUnlessSubscribe();
    this._bindEvents();
    this._bindPromoEvents();
    this._bindPromoSignup();
    this._autoApplyPromoFromUrl();
    this._updateMixToggleVisibility();
    this._updatePriceDisplay();
    this._updateCtaText();
    this._enforcePreorderCta();
    this._updateNutritionIngredients();
    this._initStickyCta();
    this._bindSubSwitch();
    this._updateSubNudges();
    /* 구독 pane은 초기에 hidden이지만 카드 가격/취소선을 미리 채워둔다 —
       탭 전환 순간 빈 칸이 보이지 않도록. */
    this._updateSubPriceDisplay();
  }

  /* 장치 B — 일회성 화면의 전환 라인을 누르면 구독 모드로 넘어간다.
     세그먼트 라디오를 실제로 체크해 기존 상태 로직을 그대로 태운다. */
  VgBuyBox.prototype._bindSubSwitch = function () {
    var el = this.section.querySelector(SEL.subSwitch);
    if (!el) return;
    var self = this;
    this._addHandler(el, 'click', function () {
      var label = self.section.querySelector('[data-purchase-type="subscribe"]');
      if (!label) return;
      var radio = label.querySelector('input[type="radio"]');
      if (radio) { radio.checked = true; }
      self._onPurchaseTypeSelect(label);
      label.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  };

  /* Pre-order is always orderable — clear any stale `disabled` baked into a
     cached server render at init time so the CTA is never grey before the
     shopper interacts. No-op outside pre-order mode. */
  VgBuyBox.prototype._enforcePreorderCta = function () {
    var ctaBtn = this.section.querySelector(SEL.ctaBtn);
    if (!ctaBtn || ctaBtn.dataset.preorderMode !== 'true') return;
    ctaBtn.disabled = false;
    var variantInput = this.section.querySelector(SEL.variantInput);
    if (variantInput) variantInput.disabled = false;
    this._updateCtaText();
  };

  VgBuyBox.prototype._buildBundleMap = function () {
    /* Prefer market-contextual variant prices (Liquid renders USD for the US
       market) — template price_cents are CAD-fixed and only a fallback. */
    var map = {};
    var bm = (typeof window !== 'undefined' && window.VGBMv2) || null;
    var variants = this.productData.variants || [];
    for (var v = 0; v < variants.length; v++) {
      var label = (variants[v].options || []).join(' ');
      var q = bm && bm.parseQtyFromLabel ? bm.parseQtyFromLabel(label) : null;
      if (q && !map[q]) map[q] = variants[v].price;
    }
    var bundles = (this.productData.bundles || []).filter(Boolean);
    for (var i = 0; i < bundles.length; i++) {
      if (!map[bundles[i].qty]) map[bundles[i].qty] = bundles[i].price;
    }
    return map;
  };

  VgBuyBox.prototype._buildPromoDiscountMap = function () {
    var map = {};
    var bundles = (this.productData.bundles || []).filter(Boolean);
    for (var i = 0; i < bundles.length; i++) {
      map[bundles[i].qty] = bundles[i].promoDiscount || 0;
    }
    return map;
  };

  VgBuyBox.prototype._bindPromoEvents = function () {
    var self = this;
    var promo = this.productData.promo;
    if (!promo || !promo.enabled) return;

    var applyBtn = this.section.querySelector('[data-promo-apply]');
    var input = this.section.querySelector('[data-promo-input]');
    if (!applyBtn || !input) return;

    var handleApply = function () { self._onPromoApply(); };
    this._addHandler(applyBtn, 'click', handleApply);
    this._addHandler(input, 'keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handleApply(); }
    });
  };

  VgBuyBox.prototype._autoApplyPromoFromUrl = function () {
    var promo = this.productData.promo;
    if (!promo || !promo.enabled) return;

    var input = this.section.querySelector('[data-promo-input]');
    if (!input) return;

    /* Show the visual discount whenever the REAL discount is active (cookie),
       regardless of the URL param — Shopify's /discount/ redirect can drop the
       ?discount= query, so the cookie is the reliable source of truth. The
       ?discount= param is the fallback trigger for first-time arrivals (e.g.
       ad links) that have not yet been routed through /discount/. */
    var fx = (typeof window !== 'undefined' && window.VGSiteFixes) || null;
    var promoCode = promo.code || '';
    var cookieActive = fx && fx.cookieHasDiscount && fx.cookieHasDiscount(document.cookie, promoCode);

    if (cookieActive) {
      input.value = promoCode;
      this._onPromoApply();
      return;
    }

    var paramCode = new URLSearchParams(window.location.search).get('discount');
    if (paramCode) {
      input.value = paramCode;
      this._onPromoApply();
    }
  };

  VgBuyBox.prototype._initStickyCta = function () {
    var bar = this.section.querySelector('[data-vg-sticky-cta]');
    var cta = this.section.querySelector(SEL.ctaBtn);
    if (!bar || !cta || !('IntersectionObserver' in window)) return;

    var btn = bar.querySelector('[data-vg-sticky-btn]');
    if (btn) {
      this._addHandler(btn, 'click', function () {
        /* Act, don't navigate: the label promises "Add to Cart", so add to cart.
           Falls back to scrolling only when the real CTA can't be actioned. */
        if (cta.disabled) {
          cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        cta.click();
      });
    }

    var decide = (window.VGSiteFixes && window.VGSiteFixes.shouldShowStickyCta)
      || function (intersecting, vw) { return !intersecting && vw < 750; };

    this._stickyObserver = new IntersectionObserver(function (entries) {
      var show = decide(entries[0].isIntersecting, window.innerWidth);
      bar.classList.toggle('is-visible', show);
    });
    this._stickyObserver.observe(cta);
  };

  VgBuyBox.prototype._onPromoApply = function () {
    var promo = this.productData.promo;
    if (!promo) return;

    var input = this.section.querySelector('[data-promo-input]');
    var msgEl = this.section.querySelector('[data-promo-msg]');
    var promoSection = this.section.querySelector('[data-promo-section]');
    if (!input || !msgEl) return;

    var entered = (input.value || '').trim().toUpperCase();
    var validCode = (promo.code || '').trim().toUpperCase();

    if (this.promoApplied) {
      /* Toggle off — remove promo */
      this.promoApplied = false;
      input.value = '';
      input.disabled = false;
      msgEl.hidden = true;
      msgEl.className = 'vg-buy__promo-msg';
      if (promoSection) promoSection.classList.remove('vg-buy__promo--applied');
      var applyBtn = this.section.querySelector('[data-promo-apply]');
      if (applyBtn) applyBtn.textContent = 'Apply';
      try { sessionStorage.removeItem('vg-promo-code'); } catch (e) { /* private mode */ }
      this._updatePriceDisplay();
      this._updateBundleBadges();
      return;
    }

    if (!entered) {
      msgEl.hidden = false;
      msgEl.className = 'vg-buy__promo-msg vg-buy__promo-msg--error';
      msgEl.textContent = 'Please enter a code.';
      return;
    }

    if (entered === validCode) {
      /* Ensure the REAL Shopify discount is set (not just visual) so the PDP
         price matches checkout. Routes through the existing /discount/ link. */
      var decision = this._ensureRealDiscount(promo.code || entered);
      if (decision === 'navigate') return; /* page is reloading via /discount/ */
      if (decision === 'failed') {
        /* /discount/ didn't set the cookie (code expired/invalid) — show an
           honest message instead of a fake discount. Loop-safe. */
        msgEl.hidden = false;
        msgEl.className = 'vg-buy__promo-msg vg-buy__promo-msg--error';
        msgEl.textContent = promo.expiredText || 'This code is no longer valid.';
        return;
      }
      /* decision === 'active' → real discount confirmed; show visual */
      this.promoApplied = true;
      input.disabled = true;
      msgEl.hidden = false;
      msgEl.className = 'vg-buy__promo-msg vg-buy__promo-msg--success';
      msgEl.textContent = promo.successText || 'Code applied!';
      if (promoSection) promoSection.classList.add('vg-buy__promo--applied');
      var applyBtn2 = this.section.querySelector('[data-promo-apply]');
      if (applyBtn2) applyBtn2.textContent = 'Remove';
      try { sessionStorage.setItem('vg-promo-code', entered); } catch (e) { /* private mode */ }
      this._updatePriceDisplay();
      this._updateBundleBadges();
    } else {
      msgEl.hidden = false;
      msgEl.className = 'vg-buy__promo-msg vg-buy__promo-msg--error';
      msgEl.textContent = promo.errorText || 'Invalid code.';
    }
  };

  /* Make the typed/auto-applied code a REAL Shopify discount via /discount/.
     Returns 'active' | 'navigate' | 'failed'. No-ops to 'active' in the theme
     editor (design mode) and if the helper module is unavailable, so the
     preview/fallback never gets stuck redirecting. */
  VgBuyBox.prototype._ensureRealDiscount = function (code) {
    var fx = (typeof window !== 'undefined' && window.VGSiteFixes) || null;
    if (!fx || !fx.discountApplyDecision) return 'active';
    if (window.Shopify && window.Shopify.designMode) return 'active';

    var attemptKey = 'vg-disc-attempt-' + (code || '').toString().toLowerCase();
    var attempted = false;
    try { attempted = sessionStorage.getItem(attemptKey) === '1'; } catch (e) { /* private mode */ }

    var decision = fx.discountApplyDecision(document.cookie, code, attempted);
    if (decision === 'navigate') {
      try { sessionStorage.setItem(attemptKey, '1'); } catch (e) { /* private mode */ }
      var url = fx.buildDiscountRedirectUrl(code, window.location.pathname, window.location.search);
      window.location.replace(url);
    } else if (decision === 'active') {
      /* Real discount confirmed — clear the one-shot guard so a LEGITIMATE
         re-apply later works (Shopify moves the discount_code cookie into the
         checkout session, so it can disappear after visiting checkout). The
         guard only stays set for genuinely invalid/expired codes, which never
         reach 'active' — so this stays loop-safe. */
      try { sessionStorage.removeItem(attemptKey); } catch (e) { /* private mode */ }
    }
    return decision;
  };

  VgBuyBox.prototype._bindPromoSignup = function () {
    var self = this;
    var promo = this.productData.promo;
    if (!promo || !promo.enabled) return;

    var toggle = this.section.querySelector('[data-promo-signup-toggle]');
    var formWrap = this.section.querySelector('[data-promo-email-form]');
    var submitBtn = this.section.querySelector('[data-promo-email-submit]');
    var emailInput = this.section.querySelector('[data-promo-email-input]');
    var msgEl = this.section.querySelector('[data-promo-email-msg]');
    if (!toggle || !formWrap) return;

    this._addHandler(toggle, 'click', function () {
      var isHidden = formWrap.hidden;
      formWrap.hidden = !isHidden;
      if (isHidden && emailInput) emailInput.focus();
    });

    if (!submitBtn || !emailInput) return;

    var doSubscribe = function () {
      var email = (emailInput.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (msgEl) { msgEl.hidden = false; msgEl.className = 'vg-buy__promo-email-msg vg-buy__promo-email-msg--error'; msgEl.textContent = 'Please enter a valid email.'; }
        return;
      }
      var listId = promo.klaviyoListId || 'Wd2Meh';
      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WjG3kr', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              custom_source: 'Veggiet PDP Promo Signup'
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      })
      .then(function (res) {
        if (res.ok || res.status === 202) {
          formWrap.innerHTML = '<p class="vg-buy__promo-email-success">Check your inbox for your code!</p>';
          toggle.hidden = true;

          if (typeof fbq === 'function') {
            fbq('track', 'Lead', {
              content_name: 'pdp_promo_signup',
              content_category: 'email_capture',
              value: 0,
              currency: 'CAD'
            });
          }
        } else {
          throw new Error('Subscribe failed');
        }
      })
      .catch(function () {
        if (msgEl) { msgEl.hidden = false; msgEl.className = 'vg-buy__promo-email-msg vg-buy__promo-email-msg--error'; msgEl.textContent = 'Something went wrong. Try again.'; }
        submitBtn.disabled = false;
        submitBtn.textContent = 'Subscribe';
      });
    };

    this._addHandler(submitBtn, 'click', doSubscribe);
    this._addHandler(emailInput, 'keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); doSubscribe(); }
    });
  };

  VgBuyBox.prototype._updateBundleBadges = function () {
    var self = this;
    var singleBoxPrice = this.bundleMap[1] || 4790;
    this.section.querySelectorAll(SEL.bundleLabel).forEach(function (label) {
      var qty = parseInt(label.dataset.bundleQty, 10);
      var existingSavings = label.querySelector('.vg-buy__promo-savings');
      if (existingSavings) existingSavings.remove();
      var baseBadge = label.querySelector('.vg-buy__bundle-badge');

      if (self.promoApplied) {
        var discount = self.promoDiscountMap[qty] || 0;
        if (discount > 0) {
          /* Show combined final discount (bundle + promo) as a single badge */
          var bundlePrice = self.bundleMap[qty] || (qty * singleBoxPrice);
          var effectivePrice = Math.round(bundlePrice * (1 - discount / 100));
          var finalPct = Math.round((1 - effectivePrice / (singleBoxPrice * qty)) * 100);
          var badge = document.createElement('span');
          badge.className = 'vg-buy__promo-savings';
          badge.textContent = finalPct + '% OFF';
          label.appendChild(badge);
          if (baseBadge) baseBadge.style.display = 'none';
        } else if (baseBadge) {
          baseBadge.style.display = '';
        }
      } else if (baseBadge) {
        baseBadge.style.display = '';
      }
    });
  };

  VgBuyBox.prototype._getInitialOptions = function () {
    var options = {};
    var activeFlavorEl = this.section.querySelector('.vg-buy__flavor.is-active');
    if (activeFlavorEl) {
      options.flavor = activeFlavorEl.dataset.flavorValue;
    } else if (this.section.dataset.pdpFlavor) {
      /* Single-flavor products have no flavor radio — derive flavor from the
         product so nutrition + ingredients render for the correct flavor. */
      options.flavor = this.section.dataset.pdpFlavor;
    }
    return options;
  };

  VgBuyBox.prototype._getSelectedBundleQty = function () {
    var el = this.section.querySelector('.vg-buy__bundle.is-active');
    return el ? parseInt(el.dataset.bundleQty, 10) : 1;
  };

  VgBuyBox.prototype._getSelectedPurchaseType = function () {
    var el = this.section.querySelector('.vg-buy__option.is-active');
    return el ? el.dataset.purchaseType : 'onetime';
  };

  VgBuyBox.prototype._addHandler = function (el, event, fn) {
    el.addEventListener(event, fn);
    this._handlers.push({ el: el, event: event, fn: fn });
  };

  /* Safety net: a selling plan may only ride along when the shopper has
     actually chosen subscribe mode — anything else is an accidental
     subscription (legacy markup used to pre-fill the first plan). */
  VgBuyBox.prototype._clearPlanUnlessSubscribe = function () {
    if (this.purchaseType === 'subscribe') return;
    var sellingPlanInput = this.section.querySelector(SEL.sellingPlanInput);
    if (sellingPlanInput) sellingPlanInput.value = '';
  };

  /* Order frequency cards shortest-first and default to the monthly plan —
     Appstle renders them in creation order, which is arbitrary. */
  var DEFAULT_FREQ_DAYS = 30;
  VgBuyBox.prototype._sortFreqOptions = function () {
    var bm = (typeof window !== 'undefined' && window.VGBMv2) || null;
    if (!bm || !bm.parseFreqDays) return;
    var container = this.section.querySelector('.vg-buy__freqs');
    if (!container) return;
    var labels = Array.prototype.slice.call(container.querySelectorAll(SEL.freqLabel));
    if (labels.length < 2) return;
    var withDays = labels.map(function (el) {
      return { el: el, days: bm.parseFreqDays(el.getAttribute('data-freq-raw')) };
    });
    if (withDays.some(function (x) { return x.days === null; })) return;
    withDays.sort(function (a, b) { return a.days - b.days; });
    withDays.forEach(function (x) { container.appendChild(x.el); });
    var def = withDays.filter(function (x) { return x.days === DEFAULT_FREQ_DAYS; })[0] || withDays[0];
    withDays.forEach(function (x) {
      var input = x.el.querySelector('input[name="sub_freq"]');
      var isDef = x === def;
      x.el.classList.toggle('is-active', isDef);
      if (input) input.checked = isDef;
    });
  };

  /* Replace Appstle's raw plan copy with a clean interval label
     ("Every 2 weeks") parsed from data-freq-raw. */
  VgBuyBox.prototype._humanizeFreqLabels = function () {
    var bm = window.VGBMv2;
    if (!bm || !bm.parseFreqLabel) return;
    this.section.querySelectorAll(SEL.freqLabel).forEach(function (label) {
      var span = label.querySelector('.vg-buy__freq-text');
      if (!span) return;
      var text = bm.parseFreqLabel(label.getAttribute('data-freq-raw'), span.textContent);
      span.textContent = text;
      var input = label.querySelector('input[name="sub_freq"]');
      if (input) input.setAttribute('aria-label', text);
    });
  };

  /* ── GA4 계측 브리지 (2026-08-11) ──────────────────────────────────────
     veggiet-analytics.liquid 가 듣는 CustomEvent 를 여기서 내보낸다.

     중복 억제가 필수인 이유: 선택지들이 <label> 안에 radio 를 품고 있어서
     클릭 1회에 (1) label 자체의 click, (2) label 이 radio 로 전달한 click 이
     label 까지 버블 — 총 2번 핸들러가 돈다. UI 는 멱등이라 무해했지만
     계측을 그대로 붙이면 전 이벤트가 정확히 2배가 된다.
     → 같은 (이름+페이로드) 는 같은 틱 안에서 1회만 내보낸다.          */
  VgBuyBox.prototype._emit = function (name, detail) {
    try {
      var payload = detail || {};
      var key = name + '|' + JSON.stringify(payload);

      /* 락은 반드시 '틱당 키 집합' — 단일 슬롯이면 한 클릭 안에서 뒤따라
         나가는 다른 이벤트(예: variant-change)가 슬롯을 덮어써 중복 억제가
         무력화된다. 2026-08-11 실측에서 이 방식으로 2배 집계가 재현됐다. */
      if (!this._emitSeen) {
        this._emitSeen = {};
        var self = this;
        setTimeout(function () { self._emitSeen = null; }, 0);
      }
      if (this._emitSeen[key]) return;
      this._emitSeen[key] = true;

      payload.sectionId = this.sectionId;
      window.dispatchEvent(new CustomEvent(name, { detail: payload }));
    } catch (e) { /* 계측 실패가 구매를 막아선 안 된다 */ }
  };

  VgBuyBox.prototype._emitBundleChange = function (label) {
    this._emit('veggiet:bundle-change', {
      bundleQty:    parseInt(label.dataset.bundleQty, 10) || 1,
      bundlePrice:  parseInt(label.dataset.bundlePrice, 10) || null,
      purchaseType: this.purchaseType || 'onetime'
    });
  };

  VgBuyBox.prototype._emitPurchaseTypeChange = function () {
    this._emit('veggiet:purchase-type-change', {
      purchaseType: this.purchaseType || 'onetime',
      bundleQty:    this.selectedBundleQty || 1,
      subQty:       this._getSelectedSubQty ? this._getSelectedSubQty() : null
    });
  };

  VgBuyBox.prototype._bindEvents = function () {
    var self = this;

    this.section.querySelectorAll(SEL.flavorLabel).forEach(function (label) {
      self._addHandler(label, 'click', function () { self._onFlavorSelect(label); });
      self._addHandler(label, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self._onFlavorSelect(label); }
      });
    });

    /* emit 은 반드시 이 바인딩 지점에서 — 핸들러 안에서 내보내면
       _onPurchaseTypeSelect 가 내부 호출하는 _onBundleSelect 때문에
       모드 전환 1회에 bundle-change 가 딸려 나간다. */
    this.section.querySelectorAll(SEL.bundleLabel).forEach(function (label) {
      var run = function () { self._onBundleSelect(label); self._emitBundleChange(label); };
      self._addHandler(label, 'click', run);
      self._addHandler(label, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); run(); }
      });
    });

    this.section.querySelectorAll(SEL.optionCard).forEach(function (card) {
      var run = function () { self._onPurchaseTypeSelect(card); self._emitPurchaseTypeChange(); };
      self._addHandler(card, 'click', run);
      self._addHandler(card, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); run(); }
      });
    });

    this.section.querySelectorAll(SEL.subQtyLabel).forEach(function (label) {
      var run = function () {
        self._onSubQtySelect(label);
        self._emit('veggiet:sub-qty-change', {
          subQty:       parseInt(label.dataset.subQty, 10) || null,
          purchaseType: self.purchaseType || 'subscribe'
        });
      };
      self._addHandler(label, 'click', run);
      self._addHandler(label, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); run(); }
      });
    });

    this.section.querySelectorAll(SEL.freqLabel).forEach(function (label) {
      var run = function () {
        self._onFreqSelect(label);
        /* 사람이 읽는 라벨을 우선 — data-freq-raw 에는 셀링플랜 전체 덤프가
           들어 있어("2WEEK…MIN_CYCLES=NULL…-20.0-PERCENTAGE…") GA4 차원값으로
           쓸 수 없다. raw 로 폴백할 때도 길이를 자른다. */
        var span = label.querySelector('.vg-buy__freq-text');
        var freq = span && span.textContent.trim();
        if (!freq) freq = (label.getAttribute('data-freq-raw') || '').slice(0, 40);
        self._emit('veggiet:freq-change', {
          frequency: freq || null,
          subQty:    self._getSelectedSubQty ? self._getSelectedSubQty() : null
        });
      };
      self._addHandler(label, 'click', run);
      self._addHandler(label, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); run(); }
      });
    });

    var mixCheckbox = this.section.querySelector('[data-mix-toggle] input[type="checkbox"]');
    if (mixCheckbox) {
      self._addHandler(mixCheckbox, 'change', function () {
        self.isMixed = mixCheckbox.checked;
        self._updatePriceDisplay();
        self._emit('veggiet:mix-change', { isMixed: self.isMixed });
      });
    }
  };

  VgBuyBox.prototype.destroy = function () {
    this._handlers.forEach(function (h) { h.el.removeEventListener(h.event, h.fn); });
    this._handlers = [];
  };

  VgBuyBox.prototype._onFlavorSelect = function (label) {
    this.section.querySelectorAll(SEL.flavorLabel).forEach(function (el) { el.classList.remove('is-active'); });
    label.classList.add('is-active');
    var radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    this.currentOptions.flavor = label.dataset.flavorValue;
    this._updateVariant();
    this._updatePriceDisplay();
    this._updateNutritionIngredients();
  };

  /* ── Switch Nutrition/Ingredients based on flavor ── */
  VgBuyBox.prototype._updateNutritionIngredients = function () {
    var flavor = this.currentOptions.flavor || '';
    var detect = (window.VGSiteFixes && window.VGSiteFixes.isBlackBeanFlavor)
      || function (s) { s = (s || '').toLowerCase(); return s.indexOf('black') !== -1 || s.indexOf('bean') !== -1 || s.indexOf('soritae') !== -1; };
    var isBlackBean = detect(flavor);

    // Nutrition Facts data per flavor (OSOT values)
    var nfData = isBlackBean
      ? { cal: '180', fat: '3.5g', fatDv: '4%', sodium: '200mg', sodiumDv: '9%', carb: '15g', carbDv: '5%', fiber: '13g', fiberDv: '46%', sugar: '<1g', protein: '22g', calcium: '180mg', calciumDv: '14%', iron: '3.7mg', ironDv: '20%', potassium: '340mg', potassiumDv: '8%' }
      : { cal: '170', fat: '1g', fatDv: '1%', sodium: '240mg', sodiumDv: '10%', carb: '18g', carbDv: '7%', fiber: '15g', fiberDv: '54%', sugar: '0g', protein: '22g', calcium: '230mg', calciumDv: '18%', iron: '5.2mg', ironDv: '30%', potassium: '170mg', potassiumDv: '4%' };

    var map = {
      '[data-nf-cal]': nfData.cal, '[data-nf-fat]': nfData.fat, '[data-nf-fat-dv]': nfData.fatDv,
      '[data-nf-sodium]': nfData.sodium, '[data-nf-sodium-dv]': nfData.sodiumDv,
      '[data-nf-carb]': nfData.carb, '[data-nf-carb-dv]': nfData.carbDv,
      '[data-nf-fiber]': nfData.fiber, '[data-nf-fiber-dv]': nfData.fiberDv,
      '[data-nf-sugar]': nfData.sugar, '[data-nf-protein]': nfData.protein,
      '[data-nf-calcium]': nfData.calcium, '[data-nf-calcium-dv]': nfData.calciumDv,
      '[data-nf-iron]': nfData.iron, '[data-nf-iron-dv]': nfData.ironDv,
      '[data-nf-potassium]': nfData.potassium, '[data-nf-potassium-dv]': nfData.potassiumDv
    };

    var section = this.section;
    Object.keys(map).forEach(function (sel) {
      var el = section.querySelector(sel);
      if (el) el.textContent = map[sel];
    });

    // Toggle ingredients
    var matchaIng = section.querySelector('[data-ingredients-matcha]');
    var bbIng = section.querySelector('[data-ingredients-blackbean]');
    if (matchaIng) matchaIng.style.display = isBlackBean ? 'none' : 'block';
    if (bbIng) bbIng.style.display = isBlackBean ? 'block' : 'none';
  };

  VgBuyBox.prototype._onBundleSelect = function (label) {
    this.section.querySelectorAll(SEL.bundleLabel).forEach(function (el) { el.classList.remove('is-active'); });
    label.classList.add('is-active');
    var radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;

    this.selectedBundleQty = parseInt(label.dataset.bundleQty, 10) || 1;

    /* E1 fix: bundles are real variants carrying the bundle price — switch
       the variant and submit qty 1. Falls back to the legacy 1-box × qty
       behaviour only if no matching bundle variant exists. */
    var fx = (typeof window !== 'undefined' && window.VGSiteFixes) || null;
    var bundleVariant = fx && fx.findBundleVariant
      ? fx.findBundleVariant(this.productData.variants, this.productData.options, this.selectedBundleQty)
      : null;

    var qtyInput = this.section.querySelector(SEL.qtyInput);
    if (qtyInput) qtyInput.value = bundleVariant ? 1 : this.selectedBundleQty;
    if (bundleVariant) this._applyVariant(bundleVariant);

    this._updateMixToggleVisibility();
    this._updatePriceDisplay();
  };

  VgBuyBox.prototype._onPurchaseTypeSelect = function (card) {
    this.section.querySelectorAll(SEL.optionCard).forEach(function (el) { el.classList.remove('is-active'); });
    card.classList.add('is-active');
    var radio = card.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;

    this.purchaseType = card.dataset.purchaseType;

    /* BM v2: switch panes — bundles are one-time only, subscriptions are
       qty(2-6) x 1-box variant. Selling plan NEVER attaches to a bundle. */
    var paneOne = this.section.querySelector(SEL.paneOnetime);
    var paneSub = this.section.querySelector(SEL.paneSubscribe);
    if (paneOne) paneOne.hidden = this.purchaseType === 'subscribe';
    if (paneSub) paneSub.hidden = this.purchaseType !== 'subscribe';

    if (this.purchaseType === 'subscribe') {
      this._applySubscribeState();
    } else {
      var sellingPlanInput = this.section.querySelector(SEL.sellingPlanInput);
      if (sellingPlanInput) sellingPlanInput.value = '';
      /* restore one-time bundle variant + qty */
      var activeBundle = this.section.querySelector(SEL.bundleLabel + '.is-active');
      if (activeBundle) this._onBundleSelect(activeBundle);
    }

    this._updateCtaText();
    this._updatePriceDisplay();
    this._updateSubNudges();
  };

  /* ── 구독 유도 장치 (2026-08-04) ─────────────────────────────────────
     A: 박스당 가격 · B: 일회성 pane 내 전환 라인 · C: 탭 단가 앵커
     F: CTA 하단 마찰 제거 문구 (구독 모드에서만)                        */
  VgBuyBox.prototype._updateSubNudges = function () {
    var bm = (typeof window !== 'undefined' && window.VGBMv2) || null;
    var unit = this.productData && this.productData.unitPriceCents;
    if (!bm || !unit) return;
    var disc = this.productData.subscribeDiscount || 20;
    /* 주의: bm.subTotalCents()는 수량을 최소 2로 클램프한다(1박스 구독 차단).
       박스당 단가는 클램프를 타면 안 되므로 직접 계산한다. */
    var perBox = Math.round(unit * (100 - disc) / 100);

    /* C — 비활성 탭에서도 단가를 보여준다 */
    var anchor = this.section.querySelector(SEL.subAnchor);
    if (anchor) anchor.textContent = 'from ' + this._formatMoney(perBox) + '/box';

    /* B — 일회성 화면에서 구독 가치를 노출 (방문자 100%가 봄) */
    var switchText = this.section.querySelector(SEL.subSwitchText);
    if (switchText) {
      var saved = unit - perBox;
      switchText.textContent = 'Subscribe & save — ' + this._formatMoney(perBox) +
        '/box (save ' + this._formatMoney(saved) + ' per box) · always free shipping · cancel anytime';
    }

    /* F — 해지 자유는 구독일 때만 의미가 있다 */
    var frict = this.section.querySelector(SEL.ctaFrict);
    if (frict) frict.hidden = this.purchaseType !== 'subscribe';
  };

  /* ── BM v2: subscription state ─────────────────────────────────────── */

  VgBuyBox.prototype._getSelectedSubQty = function () {
    var checked = this.section.querySelector('input[name="sub_qty"]:checked');
    var bm = (typeof window !== 'undefined' && window.VGBMv2) || null;
    var q = checked ? parseInt(checked.value, 10) : 2;
    return bm ? bm.clampSubQty(q) : Math.max(2, q);
  };

  VgBuyBox.prototype._getSelectedPlanId = function () {
    var checked = this.section.querySelector('input[name="sub_freq"]:checked');
    if (checked && checked.value) return checked.value;
    if (this.productData.sellingPlans && this.productData.sellingPlans.length > 0) {
      return this.productData.sellingPlans[0].id;
    }
    return '';
  };

  VgBuyBox.prototype._applySubscribeState = function () {
    var unitId = this.productData.unitVariantId;
    var qty = this._getSelectedSubQty();
    var planId = this._getSelectedPlanId();

    var variantInput = this.section.querySelector(SEL.variantInput);
    if (variantInput && unitId) { variantInput.value = unitId; variantInput.disabled = false; }

    var qtyInput = this.section.querySelector(SEL.qtyInput);
    if (qtyInput) qtyInput.value = qty;

    var sellingPlanInput = this.section.querySelector(SEL.sellingPlanInput);
    if (sellingPlanInput) sellingPlanInput.value = planId;

    this._updateSubPriceDisplay();
  };

  VgBuyBox.prototype._onSubQtySelect = function (label) {
    this.section.querySelectorAll(SEL.subQtyLabel).forEach(function (el) { el.classList.remove('is-active'); });
    label.classList.add('is-active');
    var radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    this._applySubscribeState();
    this._updateCtaText();
  };

  VgBuyBox.prototype._onFreqSelect = function (label) {
    this.section.querySelectorAll(SEL.freqLabel).forEach(function (el) { el.classList.remove('is-active'); });
    label.classList.add('is-active');
    var radio = label.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    this._applySubscribeState();
  };

  VgBuyBox.prototype._updateSubPriceDisplay = function () {
    var bm = (typeof window !== 'undefined' && window.VGBMv2) || null;
    if (!bm) return;
    var unit = this.productData.unitPriceCents;
    if (!unit) return;
    var disc = this.productData.subscribeDiscount || 20;
    var qty = this._getSelectedSubQty();

    var totalEl = this.section.querySelector(SEL.subTotal);
    if (totalEl) totalEl.textContent = this._formatMoney(bm.subTotalCents(unit, qty, disc));
    var compareEl = this.section.querySelector(SEL.subCompare);
    if (compareEl) compareEl.textContent = this._formatMoney(bm.compareTotalCents(unit, qty));

    /* Dollar savings alongside the 20% framing (Rule of 100: on $100+
       orders the dollar figure reads bigger than the percent). */
    var subSaveEl = this.section.querySelector('[data-sub-save]');
    if (subSaveEl) {
      var saved = bm.compareTotalCents(unit, qty) - bm.subTotalCents(unit, qty, disc);
      subSaveEl.textContent = saved > 0 ? 'You save ' + this._formatMoney(saved) + ' every delivery' : '';
      subSaveEl.style.display = saved > 0 ? '' : 'none';
    }

    /* 장치 A — 박스당이 구독의 실제 우위. 총액보다 먼저 읽히도록 별도 행에 쓴다. */
    var perBox = Math.round(bm.subTotalCents(unit, qty, disc) / qty);
    var perBoxEl = this.section.querySelector(SEL.subPerBox);
    if (perBoxEl) perBoxEl.textContent = this._formatMoney(perBox);
    var perBoxCmpEl = this.section.querySelector(SEL.subPerBoxCompare);
    if (perBoxCmpEl) perBoxCmpEl.textContent = this._formatMoney(unit);

    /* per-card subscription prices — 구독은 정가 대비 일률 20%라
       일회성 번들 카드와 같은 문법(총액 + 취소선 정가 + SAVE 배지)으로 표기 */
    var self = this;
    this.section.querySelectorAll(SEL.subQtyLabel).forEach(function (labelEl) {
      var q = parseInt(labelEl.dataset.subQty, 10);
      if (!q) return;
      var priceEl = labelEl.querySelector(SEL.subQtyPrice);
      if (priceEl) priceEl.textContent = self._formatMoney(bm.subTotalCents(unit, q, disc));
      var cmpEl = labelEl.querySelector(SEL.subQtyCompare);
      if (cmpEl) cmpEl.textContent = self._formatMoney(bm.compareTotalCents(unit, q));
    });

    this._updateStickyPrice();
  };

  VgBuyBox.prototype._updateMixToggleVisibility = function () {
    var mixEl = this.section.querySelector(SEL.mixToggle);
    if (!mixEl) return;

    /* E2: "Mix Both Flavors" is not implemented end-to-end — the checkbox
       never affected what was added to the cart. Keep it hidden until a
       real mixed-bundle flow exists (re-enable by restoring qty >= 2). */
    mixEl.hidden = true;
    var checkbox = mixEl.querySelector('input[type="checkbox"]');
    if (checkbox) { checkbox.checked = false; this.isMixed = false; }
  };

  VgBuyBox.prototype._updateVariant = function () {
    var matchingVariant = this._findVariantByOptions();
    if (!matchingVariant) return;
    this._applyVariant(matchingVariant);
  };

  VgBuyBox.prototype._applyVariant = function (matchingVariant) {
    var ctaBtn = this.section.querySelector(SEL.ctaBtn);
    var preorderMode = !!(ctaBtn && ctaBtn.dataset.preorderMode === 'true');

    /* Pre-order mode is always orderable (oversell policy), so never gate the
       CTA or variant input on `available` — guards against stale/edge-cached
       renders that baked in `available:false` and produced a grey, unclickable
       "Pre-Order Now" button. */
    var fx = (typeof window !== 'undefined' && window.VGSiteFixes) || null;
    var disable = fx && fx.shouldDisableCta
      ? fx.shouldDisableCta(matchingVariant.available, preorderMode)
      : (!matchingVariant.available && !preorderMode);

    var variantInput = this.section.querySelector(SEL.variantInput);
    if (variantInput) {
      variantInput.value = matchingVariant.id;
      variantInput.disabled = disable;
    }

    if (ctaBtn) {
      ctaBtn.disabled = disable;
      if (disable) {
        var span = ctaBtn.querySelector('span');
        var soldText = ctaBtn.dataset.soldOutText || 'Sold Out';
        if (span) { span.textContent = soldText; } else { ctaBtn.textContent = soldText; }
      } else {
        this._updateCtaText();
      }
    }

    /* _emit 경유 — label/radio 이중 클릭으로 같은 틱에 2번 나가던 것을 1번으로 */
    this._emit('veggiet:variant-change', {
      variantId: matchingVariant.id, variant: matchingVariant
    });
  };

  VgBuyBox.prototype._findVariantByOptions = function () {
    if (!this.productData.variants.length) return null;
    if (!this.currentOptions.flavor) return this.productData.variants[0];

    var options = this.productData.options || [];
    var flavorIdx = -1;
    for (var i = 0; i < options.length; i++) {
      var opt = options[i].toLowerCase();
      if (opt === 'flavor' || opt === 'flavour' || opt === 'taste') { flavorIdx = i; break; }
    }
    if (flavorIdx === -1) return this.productData.variants[0];

    var target = this.currentOptions.flavor;
    for (var j = 0; j < this.productData.variants.length; j++) {
      if (this.productData.variants[j].options[flavorIdx] === target) return this.productData.variants[j];
    }
    return this.productData.variants[0];
  };

  VgBuyBox.prototype._getBundlePrice = function () {
    return this.bundleMap[this.selectedBundleQty] || (this.selectedBundleQty * 4790);
  };

  VgBuyBox.prototype._getPromoDiscount = function () {
    if (!this.promoApplied) return 0;
    return this.promoDiscountMap[this.selectedBundleQty] || 0;
  };

  VgBuyBox.prototype._updatePriceDisplay = function () {
    var bundlePrice = this._getBundlePrice();
    var discount = this.productData.subscribeDiscount || 20;
    var promoDiscount = this._getPromoDiscount();

    /* Apply promo discount to bundle price */
    var effectiveBundlePrice = bundlePrice;
    if (promoDiscount > 0) {
      effectiveBundlePrice = Math.round(bundlePrice * (1 - promoDiscount / 100));
    }

    var subscribeTotal = Math.round(effectiveBundlePrice * (1 - discount / 100));
    var onetimeTotal = effectiveBundlePrice;
    var singleBoxPrice = this.bundleMap[1] || 4790;
    var compareTotal = singleBoxPrice * this.selectedBundleQty;

    var subscribePriceEl = this.section.querySelector(SEL.subscribePrice);
    if (subscribePriceEl) subscribePriceEl.textContent = this._formatMoney(subscribeTotal);

    var comparePriceEl = this.section.querySelector(SEL.comparePrice);
    if (comparePriceEl) {
      var showCompare = compareTotal > effectiveBundlePrice || this.purchaseType === 'subscribe' || promoDiscount > 0;
      comparePriceEl.style.display = showCompare ? 'block' : 'none';
      if (this.purchaseType === 'subscribe') {
        comparePriceEl.textContent = this._formatMoney(bundlePrice);
      } else if (promoDiscount > 0) {
        comparePriceEl.textContent = this._formatMoney(bundlePrice);
      } else {
        comparePriceEl.style.display = compareTotal > bundlePrice ? 'block' : 'none';
        comparePriceEl.textContent = this._formatMoney(compareTotal);
      }
    }

    var onetimePriceEl = this.section.querySelector(SEL.onetimePrice);
    if (onetimePriceEl) onetimePriceEl.textContent = this._formatMoney(onetimeTotal);

    /* Dollar savings next to the % badge (Rule of 100). */
    var onetimeSaveEl = this.section.querySelector('[data-onetime-save]');
    if (onetimeSaveEl) {
      var savedNow = compareTotal - onetimeTotal;
      onetimeSaveEl.textContent = savedNow > 0 ? 'You save ' + this._formatMoney(savedNow) : '';
      onetimeSaveEl.style.display = savedNow > 0 ? '' : 'none';
    }

    /* One-time compare-at strikethrough (per selected bundle variant) */
    var onetimeCompareEl = this.section.querySelector('[data-onetime-compare]');
    if (onetimeCompareEl) {
      var fxC = (typeof window !== 'undefined' && window.VGSiteFixes) || null;
      var bvC = fxC && fxC.findBundleVariant ? fxC.findBundleVariant(this.productData.variants, this.productData.options, this.selectedBundleQty) : null;
      var compareCents = bvC && bvC.compareAtPrice ? bvC.compareAtPrice : 0;
      if (compareCents > onetimeTotal && promoDiscount === 0) {
        onetimeCompareEl.textContent = this._formatMoney(compareCents);
        onetimeCompareEl.style.display = '';
      } else {
        onetimeCompareEl.style.display = 'none';
      }
    }

    this.section.querySelectorAll(SEL.pricePerUnit).forEach(function (el) {
      var perBox = Math.round(effectiveBundlePrice / this.selectedBundleQty);
      if (this.purchaseType === 'subscribe') {
        perBox = Math.round(subscribeTotal / this.selectedBundleQty);
      }
      el.textContent = this._formatMoney(perBox) + '/box';
    }.bind(this));

    this._updateStickyPrice();

    /* E5: the one-time price element shows the bundle TOTAL — keep the unit
       label honest ("per box" at qty 1, "for N boxes" otherwise). */
    var unitEl = this.section.querySelector('.vg-buy__option[data-purchase-type="onetime"] .vg-buy__option-price-unit');
    if (unitEl) {
      if (!unitEl.dataset.vgOriginalLabel) unitEl.dataset.vgOriginalLabel = unitEl.textContent.trim();
      var labelFn = (typeof window !== 'undefined' && window.VGSiteFixes && window.VGSiteFixes.priceUnitLabel)
        || function (q, orig) { return q > 1 ? 'for ' + q + ' boxes' : orig; };
      unitEl.textContent = labelFn(this.selectedBundleQty, unitEl.dataset.vgOriginalLabel);
    }
  };

  /* ── 스티키 가격: 표시 = 실제로 담기는 금액 (2026-09-25) ──────────────
     이 함수만 [data-vg-sticky-price] / [data-vg-sticky-unit] 에 쓴다.
     예전에는 _updatePriceDisplay 와 _updateSubPriceDisplay 가 각자 써서,
     진입 직후 일회성 1박스($39.90)에 구독 박스당가($31.92)가 남아 있었다. */
  VgBuyBox.prototype._updateStickyPrice = function () {
    var amountEl = this.section.querySelector('[data-vg-sticky-price]');
    if (!amountEl) return;
    var unitEl = this.section.querySelector('[data-vg-sticky-unit]');
    var amount;
    var unit;

    if (this.purchaseType === 'subscribe') {
      var bm = (typeof window !== 'undefined' && window.VGBMv2) || null;
      var unitPrice = this.productData.unitPriceCents || this.bundleMap[1] || 0;
      var subQty = this._getSelectedSubQty();
      var disc = this.productData.subscribeDiscount || 20;
      amount = bm ? bm.subTotalCents(unitPrice, subQty, disc)
                  : Math.round(unitPrice * subQty * (100 - disc) / 100);
      unit = 'per delivery · ' + subQty + ' boxes';
    } else {
      var bundlePrice = this._getBundlePrice();
      var promoDiscount = this._getPromoDiscount();
      amount = promoDiscount > 0
        ? Math.round(bundlePrice * (1 - promoDiscount / 100))
        : bundlePrice;
      var boxes = this.selectedBundleQty || 1;
      unit = boxes > 1 ? boxes + ' boxes total' : 'per box';
    }

    amountEl.textContent = this._formatMoney(amount);
    if (unitEl) unitEl.textContent = unit;
  };

  VgBuyBox.prototype._formatMoney = function (cents) {
    if (cents == null || isNaN(cents)) return '$0.00';
    var format = (this.productData && this.productData.moneyFormat) || '${{amount}}';
    var amount = (Math.abs(cents) / 100).toFixed(2);
    var amountNoDecimals = Math.floor(Math.abs(cents) / 100).toString();

    var parts = amount.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountWithCommaSeparator = intPart + '.' + (parts[1] || '00');

    return format
      .replace('{{amount_with_comma_separator}}', amountWithCommaSeparator)
      .replace('{{amount_no_decimals_with_comma_separator}}', intPart.replace(/,/g, '.'))
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_apostrophe_separator}}', amount.replace('.', "'"))
      .replace('{{amount}}', amount);
  };

  VgBuyBox.prototype._updateCtaText = function () {
    var ctaBtn = this.section.querySelector(SEL.ctaBtn);
    if (!ctaBtn || ctaBtn.disabled) return;

    var isPreorder = ctaBtn.dataset.preorderMode === 'true';
    var text;
    if (isPreorder) {
      text = ctaBtn.dataset.preorderText || 'Pre-Order Now';
    } else if (this.purchaseType === 'subscribe') {
      text = ctaBtn.dataset.subscribeText || 'START NOW';
    } else {
      text = ctaBtn.dataset.onetimeText || 'ADD TO CART';
    }

    var span = ctaBtn.querySelector('span');
    if (span) {
      span.textContent = text;
    } else {
      ctaBtn.textContent = text;
    }

    /* keep the mobile sticky button in sync — it triggers this same CTA */
    var stickyBtn = this.section.querySelector('[data-vg-sticky-btn]');
    if (stickyBtn) stickyBtn.textContent = text;
  };

  function init() {
    document.querySelectorAll(SEL.section).forEach(function (section) {
      if (instances.has(section)) return;
      var instance = new VgBuyBox(section);
      instances.set(section, instance);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector(SEL.section);
      if (section) {
        var prev = instances.get(section);
        if (prev && prev.destroy) prev.destroy();
        instances.delete(section);
        instances.set(section, new VgBuyBox(section));
      }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var section = e.target.querySelector(SEL.section);
      if (section) {
        var prev = instances.get(section);
        if (prev && prev.destroy) prev.destroy();
        instances.delete(section);
      }
    });
  }
})();
